export default {
  name: null,
  description: null,
  permissions: []
}